import * as z from 'zod';
import { shipSchema } from './createDynamicFilterZodSchema';

export const reportTemplateShipFormSchema = z.object({
  ships: z.array(shipSchema).default([]),
  attribute: z.enum(['colorBy', 'filterBy']),
});

export type reportTemplateShipValues = z.infer<
  typeof reportTemplateShipFormSchema
>;

export function createReportTemplateShipFormSchema() {
  return reportTemplateShipFormSchema;
}
